import React from "react";

const Header = () => {
  return (
    <nav className="Navbar">
      <a href="#home">Home</a>
      <a href="#about">About</a>
      <a href="#skills">Skills</a>
      <a href="#portfolio">Portfolio</a>
      <a href="#resume">Resume</a>
      <a href="#contact">Contact</a>
    </nav>
  );
};

export default Header;
